<div style="width: 100%; display: flex; flex-direction: row-reverse; margin-bottom: 1em">
  <button (click)="closeDialog()" style="padding: 0.5em">
    <img src="../../assets/icons/x.svg" />
  </button>
</div>

<div class="pdf-container" style="width: -webkit-fill-available; height: 90vh; overflow: hidden">
  <embed
    [src]="pdfToShow"
    type="application/pdf"
    style="width: inherit; height: inherit; z-index: 1; overflow: hidden; display: block"
  />
</div>
